export default "__VITE_ASSET__RvVlRmuq__"